var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tag',{attrs:{"size":"medium","type":"warning"}},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v("\n  "+_vm._s(_vm.vbDocBccInfoId ? "BCC-DT" : "BCC")+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c8f414c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/doc-in/doc-bcc-tag.vue
// module id = vmvM
// module chunks = 89